var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-momentum-list-view"},[_c('StockMomentumList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }